var map = {
  "./Activities/reducer": "58109",
  "./Agents/reducer": "99674",
  "./AgentsDashboard/reducer": "90762",
  "./Alerts/reducer": "48303",
  "./App/reducer": "16163",
  "./AwarenessCenter/CallForAction/reducer": "77646",
  "./AwarenessCenter/CallForActionForm/reducer": "18684",
  "./AwarenessCenter/Campaigns/AutonomousScheduler/reducer": "86374",
  "./AwarenessCenter/Campaigns/CampaignReport/reducer": "86925",
  "./AwarenessCenter/Campaigns/reducer": "60460",
  "./AwarenessCenter/LandingPageForm/reducer": "79213",
  "./AwarenessCenter/LandingPages/reducer": "77616",
  "./AwarenessCenter/Scenarios/reducer": "93440",
  "./AwarenessCenter/WizardCampaign/WizardCampaignEdit/reducer": "21939",
  "./AwarenessCenter/WizardCampaign/WizardSimulationCampaign/reducer": "9247",
  "./AwarenessCenter/WizardCampaign/WizardSpearPhishingCampaign/reducer": "85913",
  "./AwarenessCenter/WizardCampaign/WizardTrainingCampaign/reducer": "2922",
  "./AwarenessCenter/WizardCampaign/steps/GenerateEmailsStep/reducer": "71209",
  "./AwarenessCenter/WizardCampaign/steps/LandingPageStep/reducer": "85209",
  "./AwarenessCenter/WizardCampaign/steps/MessageStep/reducer": "3282",
  "./AwarenessCenter/WizardCampaign/steps/ReviewAndLaunchStep/reducer": "43847",
  "./AwarenessCenter/WizardCampaign/steps/ScenariosStep/reducer": "80802",
  "./AwarenessCenter/WizardCampaign/steps/SetupStep/reducer": "77884",
  "./AwarenessCenter/WizardCampaign/steps/TrainingModuleStep/reducer": "68261",
  "./AwarenessCenter/WizardCampaign/steps/reducer": "7296",
  "./AwarenessCenter/reducer": "96420",
  "./CustomizedAutoSync/reducer": "74801",
  "./DMARC/reducer": "26137",
  "./Dashboard/AtoOverview/reducer": "83842",
  "./Dashboard/Awareness/reducer": "9862",
  "./Dashboard/Home/ActivityFeed/reducer": "22130",
  "./Dashboard/Home/Campaigns/reducer": "18626",
  "./Dashboard/Home/Deepfake/reducer": "3560",
  "./Dashboard/Home/EmailOverview/reducer": "75806",
  "./Dashboard/Home/InsightWidget/reducer": "91001",
  "./Dashboard/Home/MailboxesStatus/reducer": "71639",
  "./Dashboard/Home/ResolutionCenter/reducer": "66308",
  "./Dashboard/Home/ThreatTypes/reducer": "67444",
  "./Dashboard/Home/UrgentUnclassifiedIncidentsWidget/reducer": "86885",
  "./Dashboard/Home/reducer": "34006",
  "./Dashboard/Menu/reducer": "20122",
  "./Dashboard/ThreatProtection/Flow/reducer": "64371",
  "./Dashboard/ThreatProtection/IncidentOverview/reducer": "72014",
  "./Dashboard/ThreatProtection/List/reducer": "83007",
  "./Dashboard/VisualDetection/reducer": "4660",
  "./Dashboard/reducer": "5636",
  "./Deepfake/reducer": "12349",
  "./EULAModal/reducer": "81314",
  "./EmailEncryption/reducer": "39915",
  "./EncryptionPLG/reducer": "73450",
  "./FirstLoginModal/reducer": "15676",
  "./GlobalBanner/reducer": "20013",
  "./GroupSettings/Assign/reducer": "67454",
  "./GroupSettings/Table/reducer": "67265",
  "./GroupSettings/Wizard/reducer": "83876",
  "./GroupSettings/reducer": "46946",
  "./Investigation/AccountInvestigation/reducer": "17472",
  "./Investigation/ThreatLog/reducer": "67603",
  "./Investigation/reducer": "25614",
  "./Login/reducer": "61097",
  "./Mailboxes/Management/AddMailbox/reducer": "70506",
  "./Mailboxes/Management/TagsForm/reducer": "2404",
  "./Mailboxes/Management/VipDiscovery/reducer": "39620",
  "./Mailboxes/Management/reducer": "58910",
  "./Mailboxes/Menu/reducer": "19442",
  "./Mailboxes/Segments/reducer": "61595",
  "./Mailboxes/Upload/reducer": "14720",
  "./Mailboxes/UserReport/reducer": "6276",
  "./Mailboxes/reducer": "4220",
  "./Navigation/AccountSetup/reducer": "14087",
  "./Partner/EditTenant/reducer": "80003",
  "./Partner/reducer": "65438",
  "./PartnerOptions/reducer": "60964",
  "./Polling/reducer": "7227",
  "./RedTeam/reducer": "30794",
  "./ResolutionCenter/AccountTakeOverClassificationModal/reducer": "63675",
  "./ResolutionCenter/AccountTakeOverModal/reducer": "60127",
  "./ResolutionCenter/AffMailboxesDetail/reducer": "30312",
  "./ResolutionCenter/AtoIncident/Header/reducer": "48344",
  "./ResolutionCenter/AtoIncident/reducer": "63168",
  "./ResolutionCenter/IncidentFilters/reducer": "71877",
  "./ResolutionCenter/List/reducer": "63056",
  "./ResolutionCenter/MailboxInfoModal/reducer": "1273",
  "./ResolutionCenter/QuickFilters/reducer": "1186",
  "./ResolutionCenter/RemediatedIncidents/reducer": "64183",
  "./ResolutionCenter/Report/reducer": "22102",
  "./ResolutionCenter/ReportComments/reducer": "82196",
  "./ResolutionCenter/ReportCommunicationModal/reducer": "72331",
  "./ResolutionCenter/ReportedIncidents/reducer": "19802",
  "./ResolutionCenter/Resolution/reducer": "84334",
  "./ResolutionCenter/ResolutionModal/reducer": "37291",
  "./ResolutionCenter/ScanBack/reducer": "66210",
  "./ResolutionCenter/ScannerDetail/reducer": "18967",
  "./ResolutionCenter/ServerScan/reducer": "20438",
  "./ResolutionCenter/TagsClassification/reducer": "64465",
  "./ResolutionCenter/TopBar/reducer": "21468",
  "./ResolutionCenter/reducer": "83167",
  "./Resources/reducer": "99953",
  "./ScenarioForm/reducer": "80828",
  "./ScenarioPreview/reducer": "3146",
  "./Settings/Alerts/reducer": "37393",
  "./Settings/AlertsV2/reducer": "62797",
  "./Settings/CreditsManagement/reducer": "73019",
  "./Settings/Customization/reducer": "63723",
  "./Settings/CustomizationO365/Notifications/reducer": "79171",
  "./Settings/CustomizationO365/ReportingReasons/reducer": "40342",
  "./Settings/CustomizationO365/reducer": "69140",
  "./Settings/DeepFakeGeneral/reducer": "80211",
  "./Settings/Disclaimers/reducer": "17498",
  "./Settings/EmailServer/Gsuite/reducer": "45881",
  "./Settings/EmailServer/O365/reducer": "22129",
  "./Settings/EmailServer/QuickIntegration/reducer": "51189",
  "./Settings/EmailServer/reducer": "30321",
  "./Settings/General/Licenses/reducer": "23979",
  "./Settings/General/reducer": "83874",
  "./Settings/IgnoreIpRange/reducer": "37322",
  "./Settings/Incidence/reducer": "29184",
  "./Settings/Intelligence/SpamAllowList/reducer": "96644",
  "./Settings/Intelligence/reducer": "47017",
  "./Settings/Languages/reducer": "49185",
  "./Settings/MailboxProtection/LandingForm/reducer": "59391",
  "./Settings/MailboxProtection/reducer": "92525",
  "./Settings/MalwareDetection/PSA/reducer": "43879",
  "./Settings/MalwareDetection/reducer": "46616",
  "./Settings/Menu/reducer": "94261",
  "./Settings/MicrosoftQuarantine/reducer": "74462",
  "./Settings/Notifications/CollaborationApps/reducer": "94019",
  "./Settings/Notifications/EndUser/Editor/reducer": "76645",
  "./Settings/Notifications/EndUser/Logo/reducer": "77823",
  "./Settings/Notifications/EndUser/reducer": "79591",
  "./Settings/Notifications/System/reducer": "60226",
  "./Settings/PartnerSettings/reducer": "66985",
  "./Settings/ProfileSettings/PushNotifications/reducer": "8037",
  "./Settings/ProfileSettings/reducer": "37466",
  "./Settings/Simulator/reducer": "64192",
  "./Settings/Users/reducer": "50418",
  "./Settings/Whitelist/reducer": "77763",
  "./Settings/reducer": "57699",
  "./Share/reducer": "15555",
  "./ShareReport/reducer": "1153",
  "./SpearPhishingAgent/reducer": "49706",
  "./Toasts/reducer": "39892",
  "./UpgradeLicenseModal/reducer": "8992",
  "./VendorProtection/reducer": "14113"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 3800;
